import cx from "classnames"
import React from "react"

export type RadioWithDetailsPropsType = {
  icon?: JSX.Element
  title: string
  description?: string
  name: string
  className?: string
} & React.InputHTMLAttributes<HTMLInputElement>

const RadioWithDetails = ({
  icon,
  title,
  description,
  className,
  ...inputProps
}: RadioWithDetailsPropsType) => {
  return (
    <label
      className={cx(
        "cobalt-radio-with-details",
        !description && "cobalt-radio-with-details--noDescription",
        className,
      )}
    >
      <input
        {...inputProps}
        type="radio"
        className="cobalt-radio-with-details__input"
      />
      <div className="cobalt-radio-with-details__inner">
        {icon &&
          React.cloneElement(icon, {
            className: "cobalt-radio-with-details__icon",
          })}
        <div className="cobalt-radio-with-details__content">
          <div className="cobalt-radio-with-details__title">{title}</div>
          {description && (
            <div className="cobalt-radio-with-details__description">
              {description}
            </div>
          )}
        </div>
        <div className="cobalt-radio-with-details__visual-input" />
      </div>
    </label>
  )
}

export default RadioWithDetails
